import { useTheme } from '@vivaldis/ui'

const NoResultsEmptyImage = () => {
  const theme = useTheme()

  return (
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M64 125.5C99.3 125.5 128 120.4 128 114C128 107.6 99.3 102.5 64 102.5C28.7 102.5 0 107.6 0 114C0 120.4 28.7 125.5 64 125.5Z"
        fill="#BFBFBF"
      />
      <path
        d="M89.5 41.2C92.1 41.2 94.4 42.2999 96.1 44.0999L96.4 44.5L121 74.8V94.1999H6.5V74.8L31.1 44.5C32.8 42.5 35.3 41.2 38 41.2H89.4H89.5Z"
        fill="#262626"
      />
      <path
        d="M98 12.1C99.1 12.1 100.1 12.5 100.8 13.2C101.6 13.9 102 14.8 102 15.8V100.5C102 101.5 101.6 102.4 100.8 103.1C100 103.8 99 104.2 98 104.2H30C28.9 104.2 27.9 103.8 27.2 103.1C26.4 102.4 26 101.5 26 100.5V15.7C26 14.7 26.4 13.8 27.2 13.1C28 12.4 29 12 30 12H98V12.1Z"
        fill="#262626"
      />
      <path
        d="M30 15.0996C29.6 15.0996 29.4 15.1996 29.2 15.3996C29 15.4996 29 15.6996 29 15.6996V100.4C29 100.4 29 100.6 29.2 100.7C29.4 100.9 29.7 101 30 101H98C98.4 101 98.6 100.9 98.8 100.7C99 100.6 99 100.4 99 100.4V15.6996C99 15.6996 99 15.4996 98.8 15.3996C98.6 15.1996 98.3 15.0996 98 15.0996H30Z"
        fill="white"
      />
      <path
        d="M87.2492 34.165H38.7508C37.7003 34.165 37 33.565 37 32.665C37 31.765 37.7003 31.165 38.7508 31.165H87.2492C88.2997 31.165 89 31.765 89 32.665C89 33.565 88.1246 34.165 87.2492 34.165Z"
        fill="#F0F2F5"
      />
      <path
        d="M88.4286 50H38.4286C37.5714 50 37 49.4 37 48.5C37 47.6 37.5714 47 38.4286 47H88.5714C89.4286 47 90 47.6 90 48.5C90 49.4 89.2857 50 88.4286 50Z"
        fill="#F0F2F5"
      />
      <path
        d="M87.4582 68H38.4016C37.5606 68 37 67.4 37 66.5C37 65.6 37.5606 65 38.4016 65H87.5984C88.4394 65 89 65.6 89 66.5C89 67.4 88.2992 68 87.4582 68Z"
        fill="#F0F2F5"
      />
      <path
        d="M86.9447 42H39.0553C37.8221 42 37 41.4 37 40.5C37 39.6 37.8221 39 39.0553 39H86.9447C88.1779 39 89 39.6 89 40.5C89 41.4 87.9723 42 86.9447 42Z"
        fill="#F0F2F5"
      />
      <path
        d="M58.4342 59.008L38.5634 58.992C37.6247 58.9912 36.9993 58.3907 37 57.4907C37.0007 56.5907 37.6271 55.9912 38.5658 55.992L58.4366 56.008C59.3754 56.0087 60.0007 56.6092 60 57.5092C59.9993 58.4092 59.2165 59.0086 58.4342 59.008Z"
        fill="#F0F2F5"
      />
      <path
        d="M55.6395 26H38.3605C37.5442 26 37 25.4 37 24.5C37 23.6 37.5442 23 38.3605 23H55.6395C56.4558 23 57 23.6 57 24.5C57 25.4 56.3197 26 55.6395 26Z"
        fill="#F0F2F5"
      />
      <path
        d="M88.0272 26H62.9728C61.7891 26 61 25.4 61 24.5C61 23.6 61.7891 23 62.9728 23H88.0272C89.2109 23 90 23.6 90 24.5C90 25.4 89.0136 26 88.0272 26Z"
        fill="#F0F2F5"
      />
      <path
        d="M118 72.8C119.7 72.8 121 74.1 121 75.8V109.4C121 110.3 120.9 111.1 120.7 111.9C119.6 116.2 115.8 119.5 111.1 119.5H16.5C11.8 119.5 7.89998 116.2 6.89998 111.9C6.69998 111.1 6.59998 110.2 6.59998 109.4V75.8C6.59998 74.1 7.89998 72.8 9.59998 72.8H35.9C40.6 72.8 44.1 76.7 44.1 81.2C44.1 82.6 45.2 83.6 46.4 83.6H81.2C82.4 83.6 83.5 82.6 83.5 81.2C83.5 76.7 87.1 72.8 91.7 72.8H118Z"
        fill="#262626"
      />
      <path
        d="M91.7 75.8C88.8 75.8 86.5 78.3 86.5 81.2C86.5 84.2 84.1 86.6 81.2 86.6H46.4C43.5 86.6 41.1 84.2 41.1 81.2C41.1 78.2 38.8 75.7 35.9 75.7H9.59998V109.3C9.59998 109.9 9.59998 110.5 9.79998 111.1C10.6 114.2 13.3 116.5 16.5 116.5H111.1C114.3 116.5 117.1 114.2 117.8 111.1C117.9 110.5 118 109.9 118 109.3V75.7H91.7V75.8Z"
        fill={theme.colorPrimary}
      />
      <path
        opacity="0.5"
        d="M89.0793 56.8199C87.938 68.639 77.4315 77.2951 65.6124 76.1538C53.7932 75.0125 45.1371 64.506 46.2784 52.6868C47.4198 40.8677 57.9263 32.2116 69.7454 33.3529C81.5646 34.4942 90.2207 45.0008 89.0793 56.8199Z"
        fill="#91CAFF"
      />
      <path
        d="M59.4183 62.7703L76.9666 45.5291"
        stroke="#262626"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <path
        d="M59.5779 45.3696L76.807 62.9298"
        stroke="#262626"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M89.6521 63.4206C84.8507 75.4937 71.205 81.3722 59.1736 76.5505C47.1423 71.7288 41.2813 58.0329 46.0828 45.9598C50.8842 33.8866 64.5299 28.0082 76.5613 32.8298C88.5926 37.6515 94.4536 51.3475 89.6521 63.4206ZM84.8776 61.5071C81.1285 70.934 70.4736 75.5239 61.0792 71.759C51.6848 67.9941 47.1083 57.3 50.8573 47.8732C54.6064 38.4463 65.2613 33.8564 74.6557 37.6213C84.0501 41.3862 88.6266 52.0802 84.8776 61.5071Z"
        fill="#262626"
      />
      <path
        d="M78.4626 73.1284L84.3369 68.1513C85.0628 67.5363 86.1497 67.6262 86.7647 68.352L100.422 84.471C102.104 86.4561 101.858 89.4287 99.873 91.1106V91.1106C97.888 92.7925 94.9153 92.5467 93.2334 90.5617L78.4626 73.1284Z"
        fill="#262626"
      />
    </svg>
  )
}

if (process.env.NODE_ENV !== 'production') {
  NoResultsEmptyImage.displayName = 'NoResultsEmptyImage'
}

export default NoResultsEmptyImage
